import type { SVGProps } from "react";

/** Flag of Germany, drawn in a 4:3 box shared by every flag in this folder. */
export function FlagDe(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 60 45" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="60" height="15" fill="#000000" />
      <rect y="15" width="60" height="15" fill="#dd0000" />
      <rect y="30" width="60" height="15" fill="#ffce00" />
    </svg>
  );
}
